import React, {useEffect, useState} from 'react';
import {stageEnums} from '../Assets/VolteCheckVariables';
import {connect} from 'react-redux';
import StartStage from './Stages/startStage';
import InactiveStage from './Stages/inactiveStage';
import CallBackStage from './Stages/callbackStage';
import ActiveStage from './Stages/activeStage';
import SelectCellularStage from './Stages/selectCellularStage';
import {
  setStage,
  resetState,
  checkForVolteService,
  setLoading,
  createWorkOrderAuth,
  openWorkOrder,
  checkImeiForVolte,
  setSubs,
} from '../VolteCheckSlice';
import ErrorScreen from '../SharedStages/ErrorScreen';
import {Onboarding} from '../../../Page/SelfCarePage/SelfCareAsyncThunk';
import LocalLoader from '../../../Shared/Loader/LocalLoader';
import NotSupportedStage from './Stages/notSupportedStage';
import InstalledStage from './Stages/installedStage';
import ImeiStage from './Stages/imeiStage';
import OtpStage from './Stages/otpStage';

const VolteCheckComponentCellcom = (props) => {
  const [isImei, setisImei] = useState(false);
  const [usedUser, setUser] = useState('');
  const isAuthenticated =
    props.authentication?.isFullAuthenticated ||
    props.authentication?.isOtpAuthenticated ||
    props.authentication?.isOtpExtendedAuthenticated ||
    props.authentication?.isSilentOtpAuthenticated;

  const loadOnboarding = async () => {
    props.setLoading(true);
    const onboardResult = await props.Onboarding();
    props.setLoading(false);
    props.setSubs(onboardResult.payload?.subscribersByProduct?.Cellular);
    const cellularSubs = onboardResult.payload?.subscribersByProduct?.Cellular;
    if (cellularSubs && cellularSubs.length > 1 && !props.authentication.userDetails.IsFullFinance) {
      props.setStage(stageEnums.selectSubscriber);
    } else {
      checkForService();
    }
    return cellularSubs;
  };

  const loadOnboardingWithEffect = async () => {
    props.setLoading(true);
    const onboardResult = await props.Onboarding();
    const cellularSubs = onboardResult.payload?.subscribersByProduct?.Cellular;
    props.setSubs(cellularSubs);
    props.setLoading(false);
    if (cellularSubs?.length < 1 || props.authentication.userDetails.IsFullFinance) {
      props.setStage(stageEnums.insertIMEI);
      setisImei(true);
    } else {
      setisImei(false);
      if (cellularSubs?.length > 1) {
        props.setStage(stageEnums.selectSubscriber);
      } else {
        const cellNum = cellularSubs[0].productSubscriberNo;
        setUser(cellNum);
        props.setStage(stageEnums.insertIMEI);
        setisImei(true);
      }
    }

    return cellularSubs;
  };
  useEffect(async () => {
    props.resetState();

    if (isAuthenticated) {
      const subByProductLoaded = !!props.subscribersByProduct && props.subscribersByProduct?.Cellular;
      if (!subByProductLoaded) {
        await loadOnboardingWithEffect();
      } else {
        const cellularSubs = props.subscribersByProduct?.Cellular;
        props.setSubs(cellularSubs);

        if (cellularSubs && cellularSubs.length > 1 && !props.authentication.userDetails?.IsFullFinance) {
          props.setStage(stageEnums.selectSubscriber);
        } else {
          checkForService();
        }
      }
    } else {
      props.setStage(stageEnums.identification);
    }

    return () => {
      setisImei(false);
      props.resetState();
    };
  }, []);

  const checkForService = (cellNum = null, cellularSubs = props.data.cellSubscribers) => {
    if (isAuthenticated) {
      if (cellularSubs?.length > 1 && cellNum == null && !props.authentication.userDetails.IsFullFinance) {
        props.setStage(stageEnums.selectSubscriber);
        setisImei(false);
      } else {
        if (!cellularSubs?.length || props.authentication.userDetails.IsFullFinance) {
          props.setStage(stageEnums.insertIMEI);
          setisImei(true);
        } else {
          setisImei(true);
          if (cellNum != null) {
            setUser(cellNum);
            props.checkForVolteService({subscriber: cellNum});
          } else {
            props.setStage(stageEnums.insertIMEI);
          }
        }
      }
    } else {
      props.setStage(stageEnums.identification);
    }
  };

  const finishAuthentication = (isAuth = true) => {
    if (isAuth && !props.authentication.userDetails.IsFullFinance) {
      const subByProductLoaded = !!props.subscribersByProduct && props.subscribersByProduct?.Cellular;
      if (!subByProductLoaded) {
        loadOnboardingWithEffect();
      } else {
        props.setSubs(props.subscribersByProduct.Cellular);
        if (props.subscribersByProduct?.Cellular?.length < 1) {
          props.setStage(stageEnums.insertIMEI);
          setisImei(true);
        } else {
          setisImei(false);
          if (props.subscribersByProduct?.Cellular?.length > 1) {
            props.setStage(stageEnums.selectSubscriber);
          } else {
            const cellNum = props.subscribersByProduct?.Cellular[0].productSubscriberNo;
            setUser(cellNum);
            props.setStage(stageEnums.insertIMEI);
            setisImei(true);
          }
        }
      }
    } else {
      props.setStage(stageEnums.insertIMEI);
      setisImei(true);
    }
  };

  const getScreen = () => {
    switch (props.screenToShow) {
      case stageEnums.error:
        return <ErrorScreen {...props} isAuthMode={!isImei} />;
      case stageEnums.selectSubscriber:
        return <SelectCellularStage subList={props.data.cellSubscribers} onclick={checkForService} {...props} />;
      case stageEnums.active:
        return <ActiveStage {...props} isAuthMode={!isImei} />;
      case stageEnums.installed:
        return <InstalledStage {...props} />;
      case stageEnums.inactive:
        return <InactiveStage {...props} />;
      case stageEnums.notSupported:
        return <NotSupportedStage {...props} />;
      case stageEnums.insertIMEI:
        return <ImeiStage {...props} />;
      case stageEnums.callback:
        return <CallBackStage {...props} isAuthMode={!isImei} selectedSub={usedUser} />;
      case stageEnums.identification:
        return <OtpStage onFinish={finishAuthentication} {...props} />;
      case stageEnums.start:
      default:
        return <StartStage onclick={checkForService} {...props} />;
    }
  };
  return (
    <>
      {props.isLoading && <LocalLoader />}
      {getScreen()}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    screenToShow: state.volteCheckSlice.stageStep,
    data: state.volteCheckSlice,
    isLoading: state.volteCheckSlice.isLoading,
    subscribersByProduct: state.selfcarePage?.subscribersByProduct,
    authentication: state.authentication.loginData,
    otp: state.otpAuthentication,
  };
};

const mapDispatchToProps = {
  setStage,
  resetState,
  setLoading,
  checkForVolteService,
  Onboarding,
  createWorkOrderAuth,
  openWorkOrder,
  checkImeiForVolte,
  setSubs,
};

export default connect(mapStateToProps, mapDispatchToProps)(VolteCheckComponentCellcom);
